var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLinkExternal = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.113 9H12.5A4.5 4.5 0 0 0 8 13.5v2a.5.5 0 1 0 1 0v-2a3.5 3.5 0 0 1 3.5-3.5h10.613a.5.5 0 1 0 0-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.76 13.146a.5.5 0 1 0 .707.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 1 0-.708.708L22.406 9.5l-3.647 3.646ZM1 19V6h13v1a.5.5 0 1 0 1 0V5.5a.5.5 0 0 0-.5-.5H.5a.5.5 0 0 0-.5.5v14a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5V13a.5.5 0 0 0-1 0v6H1Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLinkExternal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/link-external.8384fd01adfb9d6233046c82836dc6b7.svg";